import { ROLE_ACTIONS } from "components/Actions/types";

import ManageRole from "../../ManageRole";
import { EditRoleInlineProps } from "./types";

const EditRoleInline = ({ data, isOpen, close }: EditRoleInlineProps) => {
    return (
        <ManageRole
            action={ROLE_ACTIONS.EditRole}
            rowData={data}
            isOpen={isOpen}
            close={close}
        />
    );
};

export default EditRoleInline;
